
import { useEffect, useRef, useState } from 'react';

export default function ManifestoSection() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const manifestoLines = [
    "这个世界，期待你永远如雄狮般威严，如猛虎般迅捷。",
    "却少有人问你，累不累，倦不倦。",
    "我们懂得，你的战场，在会议室，在旅途，在每一个需要扛起的家。",
    "你的能量，是世界的风景；你的内里，是我们的天地。",
    "狮虎堂，不为创造神话，只为守护你的本色。",
    "融汇三地精粹，唤醒沉睡在你体内的原生力量。",
    "狮虎之魄，养傲然之生。",
    "你，本应如此。"
  ];

  return (
    <section 
      ref={sectionRef}
      className="relative py-32 bg-[#2f3673] overflow-hidden"
    >
      {/* Background Pattern */}
      <div 
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: `url('https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/b6f154f0a5ddd4ee680f68d928bef855.png')`,
          backgroundSize: 'auto',
          backgroundRepeat: 'repeat',
          backgroundPosition: '0 0'
        }}
      ></div>
      
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="space-y-12">
          {/* Section Title */}
          <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <h2 className="text-xl md:text-2xl font-bold text-white mb-4">
              品牌宣言
            </h2>
            <div className="w-24 h-1 bg-[#f7931d] mx-auto"></div>
          </div>
          
          {/* Manifesto Content */}
          <div className="space-y-8">
            {manifestoLines.map((line, index) => (
              <div
                key={index}
                className={`transition-all duration-1000 delay-${index * 200} ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                }`}
                style={{ 
                  transitionDelay: `${index * 200}ms`,
                  fontFamily: '"Noto Serif SC", serif'
                }}
              >
                {index === 4 || index === 6 ? (
                  <p className="text-base md:text-lg font-bold text-[#f7931d] leading-relaxed">
                    {line}
                  </p>
                ) : (
                  <p className="text-sm md:text-base text-gray-200 leading-relaxed max-w-3xl mx-auto">
                    {line}
                  </p>
                )}
              </div>
            ))}
          </div>
          
          {/* CTA Button */}
          <div className={`pt-12 transition-all duration-1000 delay-1600 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}>
            <button className="bg-[#f7931d] text-white px-8 py-3 rounded-full text-sm font-semibold hover:bg-[#e6841a] transition-all duration-300 transform hover:scale-105 cursor-pointer whitespace-nowrap">
              发现你的本源力量
            </button>
          </div>
        </div>
      </div>
      
      {/* Decorative Elements */}
      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-white to-transparent"></div>
    </section>
  );
}
